import { render, staticRenderFns } from "./KursDetay.vue?vue&type=template&id=226c1cb0&"
import script from "./KursDetay.vue?vue&type=script&lang=js&"
export * from "./KursDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports